<template>
	<div class="manulife">
		<div class="container">
			<div class="manulife-bg">
				<div class="manulife-content">
					<div
						class="manulife-title"
						v-wow="{
							'animation-name': 'fadeInUp',
							'animation-duration': '1s',
							'animation-delay': '0.1s',
						}"
					>
						<div class="manulife-logo">
							<img
								v-if="$i18n.locale == 'en'"
								src="~@/assets/img/manulife-banner-logo.svg"
								alt="Manulife logo"
							/>
							<img v-else src="~@/assets/img/manulife-banner-logo-fr.svg" alt="Manuvie logo" />
						</div>
					</div>

					<div
						class="manulife-description"
						v-wow="{
							'animation-name': 'fadeInUp',
							'animation-duration': '1s',
							'animation-delay': '0.2s',
						}"
						v-html="$t('Manulife.descrtiption')"
					></div>

					<div
						class="arrow-link-container"
						v-wow="{
							'animation-name': 'fadeInUp',
							'animation-duration': '1s',
							'animation-delay': '0.6s',
						}"
					>
						<a :href="$t('Manulife.url')" class="arrow-link" target="_blank" rel="noopener noreferrer">
							<span>{{ $t('Manulife.visit') }}</span>
							<svg
								class="arrow"
								xmlns="http://www.w3.org/2000/svg"
								width="12"
								height="11"
								viewBox="0 0 12 11"
							>
								<path
									fill="#fff"
									d="M.727 4.967c.05-.008.1-.012.15-.011h8.529l-.186-.087a1.73 1.73 0 0 1-.489-.346L6.339 2.132A.895.895 0 0 1 6.214.985.865.865 0 0 1 7.51.873l4.325 4.325a.865.865 0 0 1 .001 1.224L7.51 10.747a.865.865 0 0 1-1.297-.086.895.895 0 0 1 .125-1.146l2.388-2.396a1.73 1.73 0 0 1 .432-.316l.26-.117H.924A.895.895 0 0 1 .01 5.96a.865.865 0 0 1 .716-.992z"
								/>
							</svg>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Manulife',
}
</script>

<style lang="scss">
.manulife-bg {
	background-image: url('~@/assets/img/manulife-banner-icon.png');
	background-position: 94% 50%;
	background-repeat: no-repeat;
	background-color: $greenTheme;
	color: $white;
	margin-bottom: 40px;
	padding: 40px 80px;
}

.manulife-content {
	max-width: 76%;
}

.manulife-title {
	@include flex-container;
}

.manulife-logo {
	img {
		width: 356px;
	}
}

.manulife-description {
	@extend %manulife-light;
	font-size: 16px;
	line-height: 1.5;
	margin-top: 20px;
	color: $white;

	span {
		@extend %manulife-italic;
	}
}

.arrow-link-container {
	margin-top: 30px;

	.arrow-link {
		@extend %manulife-regular;
		font-size: 18px;
		color: $white;
		letter-spacing: 1px;

		&:hover,
		&:focus {
			.arrow {
				transform: translateX(5px);
			}
		}
	}

	.arrow {
		transition: transform 0.2s ease;
		width: 12px;
		height: 11px;
		margin: 5px;
	}
}

@include tabletLandscape {
	.manulife-content {
		max-width: 65%;
	}
}

@include mobile {
	.manulife-bg {
		background-image: none;
		padding: 20px;
	}
	.manulife-content {
		max-width: 100%;
	}

	.manulife-before-title {
		h2 {
			font-size: 22px;
		}
	}
}
</style>
